import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Table } from '@gamesb42/ui-kit';

import useTransaction from 'hooks/api/useTransaction';
import { formatAmount, getCurrencyWithCode, formatBankAccount } from 'helpers/formatters';

const EntriesTable: FC = () => {
  const { t } = useTranslation();
  const { entriesData, getEntriesIsFetching } = useTransaction();

  if (getEntriesIsFetching) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Loading entries...</div>;
  }

  // Данные приходят напрямую как массив, а не в wrapper объекте
  if (!entriesData || !Array.isArray(entriesData) || entriesData.length === 0) {
    return <h3 style={{ color: 'gray' }}>{t('forms.transaction.transactionNotFound')}</h3>;
  }

  const columns = [
    {
      title: t('tables.debit'),
      dataIndex: 'debit',
      key: 'debit',
      render: (value: any, record: any) =>
        `${record.sender.account_type_name} ${formatBankAccount(record.sender.account)}`,
    },
    {
      title: t('tables.credit'),
      dataIndex: 'credit',
      key: 'credit',
      render: (value: any, record: any) =>
        `${record.recipient.account_type_name} ${formatBankAccount(record.recipient.account)}`,
    },
    {
      title: t('tables.amount'),
      dataIndex: 'amount',
      key: 'amount',
      align: 'right' as const,
      render: (value: any, record: any) =>
        `${getCurrencyWithCode(Number(record.amount.currency))}${formatAmount(Math.abs(record?.amount.amount || 0))}`,
    },
  ];

  return <Table columns={columns} dataSource={entriesData} />;
};

export default EntriesTable;
